import { render, staticRenderFns } from "./modalViewTransaction.vue?vue&type=template&id=49385e74&"
import script from "./modalViewTransaction.vue?vue&type=script&lang=js&"
export * from "./modalViewTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports